var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "sticker",
      style: {
        width: _vm.widthMm + "mm",
        height: _vm.heightMm + "mm",
        paddingTop: _vm.parameters.top + "px",
        paddingRight: _vm.parameters.right + "px",
        paddingBottom: _vm.parameters.bottom + "px",
        paddingLeft: Number(_vm.parameters.left || 0) + _vm.leadingPadPx + "px",
        fontSize: _vm.effectiveFontSize + "pt",
        "--footer-scale": _vm.footerScale,
      },
    },
    [
      _c("div", {
        class: _vm.companyName.startsWith("Bergsoe")
          ? "bg-img"
          : "panya-bg-img",
        style: _vm.watermarkStyle,
      }),
      _c("div", { staticClass: "cell-content" }, [
        _c(
          "div",
          {
            staticClass: "font-weight-bold",
            style: `font-size: ${_vm.scaledHeaderPt}pt`,
          },
          [_vm._v(" " + _vm._s(_vm.companyName) + " ")]
        ),
        _c("div", { staticClass: "qr-row flex-grow-1" }, [
          _vm.qrDataUrl
            ? _c("img", {
                staticClass: "qr-img",
                style: {
                  width: _vm.scaledQrSize + "px",
                  height: _vm.scaledQrSize + "px",
                },
                attrs: { src: _vm.qrDataUrl },
              })
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "info-col",
              style: { marginLeft: _vm.scaledQrSize + 12 + "px" },
            },
            [
              _c("table", { staticClass: "qr-info" }, [
                _c(
                  "tbody",
                  [
                    _vm.parameters.brandName
                      ? _c("tr", [
                          _c(
                            "td",
                            { staticClass: "font-weight-light label-col" },
                            [_vm._v("Brand")]
                          ),
                          _c("td", [_vm._v(_vm._s(_vm.parameters.brandName))]),
                        ])
                      : _vm._e(),
                    _vm.commodityName
                      ? _c("tr", [
                          _c(
                            "td",
                            { staticClass: "font-weight-light label-col" },
                            [_vm._v("Commodity")]
                          ),
                          _c("td", [_vm._v(_vm._s(_vm.commodityName))]),
                        ])
                      : _vm._e(),
                    _vm.worksheet.documentNumber
                      ? _c("tr", [
                          _c(
                            "td",
                            { staticClass: "font-weight-light label-col" },
                            [_vm._v("Lot No")]
                          ),
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm.worksheet.documentNumber) +
                                "-" +
                                _vm._s(_vm.lotIndex)
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm.entry.netWeight != null
                      ? _c("tr", [
                          _c(
                            "td",
                            { staticClass: "font-weight-light label-col" },
                            [_vm._v("Net Weight")]
                          ),
                          _c("td", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("formatNumber")(
                                    _vm.entry.netWeight +
                                      (_vm.entry.netAdjustmentWeight || 0)
                                  )
                                ) +
                                " " +
                                _vm._s(
                                  _vm.productInfo
                                    ? _vm.productInfo.measureWeight
                                    : ""
                                ) +
                                " "
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._l(
                      _vm.parameters.optionalFields,
                      function (field, index) {
                        return _c("tr", { key: index }, [
                          _c(
                            "td",
                            { staticClass: "font-weight-light label-col" },
                            [_vm._v(_vm._s(field.label))]
                          ),
                          _c("td", [_vm._v(_vm._s(field.value))]),
                        ])
                      }
                    ),
                    _c("tr", [
                      _c("td", { staticClass: "font-weight-light label-col" }, [
                        _vm._v("Date"),
                      ]),
                      _c("td", [
                        _vm._v(_vm._s(_vm._f("formatDateYear")(_vm.labelDate))),
                      ]),
                    ]),
                    _vm._m(0),
                  ],
                  2
                ),
              ]),
            ]
          ),
        ]),
        _vm.companyAddress
          ? _c(
              "div",
              {
                ref: "footer",
                staticClass: "ma-0 pa-0 font-weight-light footer-text",
                style: `font-size: ${_vm.scaledFooterPt}pt;`,
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.companyAddress) +
                    " Tel: " +
                    _vm._s(_vm.companyPhone) +
                    " "
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "text-caption font-weight-light font-size-small d-print-none",
                    staticStyle: { float: "right", position: "relative" },
                  },
                  [_vm._v(" " + _vm._s(_vm.lotIndex) + " ")]
                ),
              ]
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "font-weight-light label-col" }, [
        _vm._v("Origin"),
      ]),
      _c("td", [_vm._v("Thailand")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }